// Kayıt sırasında girilen kohort kodunun / kişisel davet tokenının bekletildiği yer.
//
// NEDEN: kohort rızası genel hukuki onayın YERİNE geçmez, ÜSTÜNE gelir. Onay
// kapısının kuralı "kabul edilmeden hiçbir ekran görülmez" olduğu için kohort
// rıza ekranı da genel onaydan ÖNCE gösterilemez. Kod bu yüzden kayıt anında
// saklanır, kullanıcı doğrulama ve onay adımlarını geçtikten sonra postAuth
// tarafından tüketilir.
//
// İki giriş yolu iki AYRI anahtarda durur: paylaşımlı kod ile kişiye özel token
// aynı kutuya konsaydı, hangisinin geldiğini anlamak için tokenın biçimine
// bakmak gerekirdi. Token birincildir (koltuk o kişiye ayrılmıştır), tüketim
// sırasını [postAuth.ts] belirler.
const KEY = "pp_pending_cohort";
const INVITE_KEY = "pp_pending_cohort_invite";

export function setPendingCohortCode(code: string): void {
  try {
    if (code) localStorage.setItem(KEY, code);
  } catch { /* storage kapalıysa akış kodsuz devam eder */ }
}

export function getPendingCohortCode(): string {
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function clearPendingCohortCode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch { /* yoksay */ }
}

export function setPendingCohortInvite(token: string): void {
  try {
    if (token) localStorage.setItem(INVITE_KEY, token);
  } catch { /* storage kapalıysa akış davetsiz devam eder */ }
}

export function getPendingCohortInvite(): string {
  try {
    return localStorage.getItem(INVITE_KEY) ?? "";
  } catch {
    return "";
  }
}

export function clearPendingCohortInvite(): void {
  try {
    localStorage.removeItem(INVITE_KEY);
  } catch { /* yoksay */ }
}

/** Rıza ekranı bittiğinde iki yol da kapanır: kabul de ret de tek seferliktir. */
export function clearPendingCohort(): void {
  clearPendingCohortCode();
  clearPendingCohortInvite();
}
